import { render } from "./mobilenavbar.vue?vue&type=template&id=4a073958&scoped=true"
import script from "./mobilenavbar.vue?vue&type=script&lang=js"
export * from "./mobilenavbar.vue?vue&type=script&lang=js"

import "./mobilenavbar.vue?vue&type=style&index=0&id=4a073958&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a073958"]])

export default __exports__